class BlogLoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.buttonText = this.querySelector(".button-text");
    this.loadingState = this.querySelector(".loading-state");
    this.nextUrl = this.dataset.nextUrl;
    this.isLoading = false;
  }
  connectedCallback() {
    this.button.addEventListener("click", () => this.loadMore());
  }
  async loadMore() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.showLoading();
    try {
      const response = await fetch(this.nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const articlesGrid = document.getElementById("articles-grid");
      const newArticles = doc.querySelectorAll("#articles-grid > div");
      newArticles.forEach((article, index) => {
        article.style.opacity = "0";
        article.style.transform = "translateY(20px)";
        articlesGrid.appendChild(article);
        setTimeout(() => {
          article.style.transition = "opacity 0.4s ease-out, transform 0.4s ease-out";
          article.style.opacity = "1";
          article.style.transform = "translateY(0)";
        }, index * 50);
      });
      const nextLoadMore = doc.querySelector("blog-load-more");
      if (nextLoadMore) {
        this.nextUrl = nextLoadMore.dataset.nextUrl;
        this.dataset.nextUrl = this.nextUrl;
        this.isLoading = false;
        this.hideLoading();
      } else {
        this.remove();
      }
    } catch (error) {
      console.error("Error loading more articles:", error);
      this.showError();
    }
  }
  showLoading() {
    this.buttonText.classList.add("hidden");
    this.loadingState.classList.remove("hidden");
    this.button.disabled = true;
  }
  hideLoading() {
    this.buttonText.classList.remove("hidden");
    this.loadingState.classList.add("hidden");
    this.button.disabled = false;
  }
  showError() {
    this.buttonText.classList.remove("hidden");
    this.loadingState.classList.add("hidden");
    this.button.disabled = false;
    this.isLoading = false;
    const originalHTML = this.buttonText.innerHTML;
    this.buttonText.textContent = "Error - Try Again";
    setTimeout(() => {
      this.buttonText.innerHTML = originalHTML;
    }, 3e3);
  }
}
if (!customElements.get("blog-load-more")) {
  customElements.define("blog-load-more", BlogLoadMore);
}
